import answerModel from 'components/answers/answerModel'
import { extractUrls, getKnovLinkRegexp, getStreamLinkRegexp } from 'components/shared/LinkPreview'
import * as cache from 'state/cache'
import { getAnswerPlayMediaItems as collectAnswerPlayMediaItems } from './playStoryMediaItems'

const getAnswerAttachmentState = answer => {
    const extractedUrls = extractUrls(answer?.delta_json)

    return answerModel.getComposeAttachmentState({
        answer,
        extractedUrls,
        hiddenPreviewUrls: [],
        resolveEmbedAnswer: embed => cache.getCachedAnswer(embed?.id) || embed,
    })
}

const getPrimaryPlayableLink = (attachmentState, extractedUrls) => {
    if (attachmentState.embeds?.length) return null

    const attachedUrlAddress = attachmentState.attachedUrlAddress
    if (
        attachedUrlAddress &&
        !getKnovLinkRegexp().test(attachedUrlAddress) &&
        !attachedUrlAddress?.match(getStreamLinkRegexp())
    ) {
        return attachedUrlAddress
    }

    return extractedUrls?.nonKnovLinks?.[0] || null
}

export const getAnswerPlayMediaItems = answer => {
    const attachmentState = getAnswerAttachmentState(answer)
    const extractedUrls = extractUrls(answer?.delta_json)
    const primaryLink = getPrimaryPlayableLink(attachmentState, extractedUrls)

    return collectAnswerPlayMediaItems(answer, { primaryLink })
}

export const getAnswerPlayMedia = answer => {
    const mediaItems = getAnswerPlayMediaItems(answer)
    const video = mediaItems.find(media => media.kind === 'video')
    const image = mediaItems.find(media => media.kind === 'image')
    const audio = mediaItems.find(media => media.kind === 'audio')

    if (video) return video
    if (image && audio) {
        return {
            kind: 'image-audio',
            imageSrc: image.src,
            file: audio.file,
        }
    }
    return image || audio || mediaItems[0]
}

export const isTrackedPlayMedia = media =>
    media?.kind === 'audio' || media?.kind === 'video' || media?.kind === 'image-audio'
